import React, { useCallback, useEffect, useMemo, useState } from "react";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import { Button, Col, Form, Modal, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap";
import { FaEdit, FaEye, FaPlus, FaSearch, FaTrash } from "react-icons/fa";
import OffCanvasHasilChecklist from "../offcanvas/OffCanvasHasilChecklist";
import DataTable from "react-data-table-component";
import ModalAddEditEvaluasi from "./ModalAddEditEvaluasi";
import SweetAlert from "react-bootstrap-sweetalert";
import { AsyncPaginate } from "react-select-async-paginate";
import JenisGrade from "../../../../utilities/primer/JenisGrade";

const ModalReviu = ({ showReviu, handleCloseReviu, dataDisposisi, dataPrimer, jenisIzin, reloadList, isEdit }) => {
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    const [valueTglInspeksi, setValueTglInspeksi] = useState(null)
    const [totalSesuai, setTotalSesuai] = useState('')
    const [totalMinor, setTotalMinor] = useState('')
    const [totalMayor, setTotalMayor] = useState('')
    const [totalKritis, setTotalKritis] = useState('')
    const [totalHasil, setTotalHasil] = useState('')
    const [keterangan, setKeterangan] = useState('')

    const [listEvaluasi, setListEvaluasi] = useState([])
    const [dataEvaluasi, setDataEvaluasi] = useState(null)
    const [loading, setLoading] = useState(false)
    const [isEditEvaluasi, setIsEditEvaluasi] = useState(null)
    const [idInspeksi, setIdInspeksi] = useState(null)

    const columnsEvaluasi = [
        {
            name: 'Nama',
            cell: row => (localStorage.getItem("role") === '6' || localStorage.getItem("role") === '1' || localStorage.getItem("role") === '7' ? row['nmEvaluator'] : "***"),
            grow: 0.5
        },
        {
            name: 'Catatan',
            cell: row => row['catatan'],
            grow: 1
        },
        {
            name: 'Tanggal Evaluasi',
            cell: row => row['tglEvaluasi'],
            grow: 0.4
        },
        {
            name: (jenisIzin === 'CPIB' || jenisIzin === 'CBIB' || jenisIzin === 'CPIBK') ? 'Grade' : ((jenisIzin === 'CPOIB' || jenisIzin === 'CDOIB') ? 'Kategori' : 'Tingkat Pengawasan'),
            cell: row => <JenisGrade kodeSert={jenisIzin} kodeGrade={row['kodeGrade']}/>,
            grow: 0.4
        },
        {
            name: 'Action',
            cell: row => (
                <div className="row">
                    <div className="col-12 mb-1">
                        <OverlayTrigger placement="bottom" overlay={
                            <Tooltip >Lihat </Tooltip>}>
                            <Button size="sm" variant="info" onClick={() => handleClickViewEvaluasi(row)}>
                                <FaEye /> Lihat
                            </Button>
                        </OverlayTrigger>{' '}
                    </div>
                    {
                        (dataPrimer?.kodeStatus === '027' || dataPrimer?.kodeStatus === '029') &&
                        <>
                            <div className="col-12 mb-1">
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Ubah </Tooltip>}>
                                    <Button size="sm" variant="warning" onClick={() => handleClickEditEvaluasi(row)}>
                                        <FaEdit /> Ubah
                                    </Button>
                                </OverlayTrigger>{' '}
                            </div>
                            <div className="col-12 mb-1">
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Hapus</Tooltip>}>
                                    <Button size="sm" variant="danger" onClick={() => handleClickDeleteEvaluasi(row)}>
                                        <FaTrash /> Hapus
                                    </Button>
                                </OverlayTrigger>{' '}
                            </div>
                        </>
                    }
                </div>
            ),
            grow: 0.5
        }
    ]

    const fetchAllData = useCallback(async () => {
        if (!dataPrimer?.nomorAju || !dataDisposisi?.noTugas || dataDisposisi.idDisposisi !== 8) {
            return
        }
        try {
            setLoading(true)
            const resInspeksi = await pbumkuService.getUmkuInspeksiDataByAjuAndNoSurat(dataPrimer.nomorAju, dataDisposisi.noTugas)
            if (resInspeksi.data !== null) {
                setValueTglInspeksi(resInspeksi.data.tglInspeksi)
                setValueKomoditas(resInspeksi?.data?.komoditas)
                setValuePeruntukan(resInspeksi?.data?.peruntukanProduk)

                const resJenisSert = await pbumkuService.getJenisSertifikasi(jenisIzin, resInspeksi?.data?.jenisSertifikasi)
                setValueJenisSertOpt(resJenisSert?.data)

                const resInspeksiHasil = await pbumkuService.getUmkuHasilInspeksiByAjuAndIdInspeksi(dataPrimer.nomorAju, resInspeksi.data.idInspeksi)
                if (resInspeksiHasil.data !== null) {
                    setTotalSesuai(resInspeksiHasil?.data?.totalSesuai)
                    setTotalMinor(resInspeksiHasil?.data?.totalMinor)
                    setTotalMayor(resInspeksiHasil?.data?.totalMayor)
                    setTotalKritis(resInspeksiHasil?.data?.totalKritis)
                    setTotalHasil(resInspeksiHasil?.data?.totalHasil)
                    setKeterangan(resInspeksiHasil?.data?.keterangan)
                }

                const resInspeksiReviu = await pbumkuService.listUmkuEvaluasiByIdInspeksi(resInspeksi?.data?.idInspeksi)
                setListEvaluasi(resInspeksiReviu?.data?.data)
                setIdInspeksi(resInspeksi?.data?.idInspeksi)
            }
            setLoading(false)
        } catch (error) {

        }
    }, [pbumkuService, dataPrimer, dataDisposisi, jenisIzin])

    useEffect(() => {
        let isMounted = true
        if (!dataPrimer) return

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };

    }, [dataPrimer, fetchAllData])

    const handleClickClose = () => {
        handleCloseReviu()
    }

    const [showHasilInspeksi, setShowHasilInspeksi] = useState(false)
    const handleCloseHasilInspeksi = () => setShowHasilInspeksi(false)
    const ViewHasilInspeksi = () => {
        setShowHasilInspeksi(true)
    }

    const [showEvaluasiTeknis, setShowEvaluasiTeknis] = useState(false)
    const handleCloseEvaluasiTeknis = () => setShowEvaluasiTeknis(false)

    const handleClickAddEvaluasi = () => {
        setIsEditEvaluasi(true)
        setShowEvaluasiTeknis(true)
    }
    const handleClickEditEvaluasi = (row) => {
        setIsEditEvaluasi(true)
        setDataEvaluasi(row)
        setShowEvaluasiTeknis(true)
    }
    const handleClickViewEvaluasi = (row) => {
        setIsEditEvaluasi(false)
        setDataEvaluasi(row)
        setShowEvaluasiTeknis(true)
    }
    const handleClickDeleteEvaluasi = (row) => {
        setListEvaluasi(prevList => {
            const filtered = prevList.filter(item => !(item.nomorAju === row.nomorAju && item.nipEvaluator === row.nipEvaluator)).map((item, idx) => ({ ...item, nomorAju: row.nomorAju }))
            return filtered
        })
    }

    const [showConfirmSimpan, setShowConfirmSimpan] = useState(false)
    const handleCloseConfirmSimpan = () => setShowConfirmSimpan(false)
    const handleClickConfimrSimpan = () => {
        setShowConfirmSimpan(true)
    }

    const [loadingSimpan, setLoadingSimpan] = useState(false)
    const [showSimpanSuccess, setShowSimpanSuccess] = useState(false)
    const [showSimpanFailed, setShowSimpanFailed] = useState(false)

    const handleCloseSuccess = () => {
        setShowSimpanSuccess(false)
        reloadList(dataPrimer.nomorAju)
    }

    const handleCloseFailed = () => {
        setShowSimpanFailed(false)
        reloadList(dataPrimer.nomorAju)
    }

    const handleClickSimpan = async () => {
        setLoadingSimpan(true)
        try {
            const resDeleteEvaluasi = await pbumkuService.deleteUmkuEvaluasiByAju(dataPrimer.nomorAju)

            if (resDeleteEvaluasi.data.kode === '200') {
                listEvaluasi.map(async (evt) => {
                    // console.log(evt)
                    let newJson = {
                        nomorAju: evt.nomorAju,
                        nipEvaluator: evt.nipEvaluator,
                        nmEvaluator: evt.nmEvaluator,
                        tglEvaluasi: evt.tglEvaluasi,
                        catatan: evt.catatan,
                        idInspeksi: idInspeksi,
                        createdBy: evt.createdBy,
                        createdDate: evt.createdDate,
                        kodeGrade: evt.kodeGrade
                    }
                    await pbumkuService.saveUmkuEvaluasi(newJson)
                })

                let jsonStatus = {
                    nomorAju: dataPrimer.nomorAju,
                    kodeStatus: '028',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem("userId"),
                    createdDate: new Date()
                }
                await pbumkuService.saveUmkuStatus(jsonStatus)

                let dataHeader = await pbumkuService.getUmkuHeader(dataPrimer.nomorAju)

                let jsonUmkuHeader = {
                    ...dataHeader?.data,
                    kodeStatus: '029'
                }
                await pbumkuService.saveUmkuHeader(jsonUmkuHeader)

                jsonStatus = {
                    nomorAju: dataPrimer.nomorAju,
                    kodeStatus: '029',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem("userId"),
                    createdDate: new Date()
                }
                await pbumkuService.saveUmkuStatus(jsonStatus)

                setShowConfirmSimpan(false)
                setShowSimpanSuccess(true)
            } else {
                setShowConfirmSimpan(false)
                setShowSimpanFailed(true)
            }
        } catch (error) {
            setShowConfirmSimpan(false)
            setShowSimpanFailed(true)
        }
        setLoadingSimpan(false)
    }
    const [valueJenisSertOpt, setValueJenisSertOpt] = useState(null)
    async function loadOptionJenisSert(search, loadedOption, { page = 1 }) {
        const response = await pbumkuService.listJenisSertifikasi(jenisIzin, search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangeJenisSert = e => {
        setValueJenisSertOpt(e)
    }

    const [valueKomoditas, setValueKomoditas] = useState(null)
    const handleChangeKomoditas = e => {
        setValueKomoditas(e.target.value)
    }

    const [valuePeruntukan, setValuePeruntukan] = useState(null)
    const handleChangePeruntukan = e => {
        setValuePeruntukan(e.target.value)
    }

    return (
        <>
            <Modal
                show={showReviu}
                onHide={handleCloseReviu}
                size="xl"
                centered
                backdrop={true}
            >
                <Modal.Header><Modal.Title><h5>Reviu Teknis {jenisIzin}</h5></Modal.Title></Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPrimer?.nomorAju} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Inspeksi</Form.Label>
                                    <Col sm="4">
                                        <Form.Control type="date" placeholder="NIB" className="form-control-sm" value={valueTglInspeksi} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    {
                        (jenisIzin === 'CPIB' || jenisIzin === 'CBIB') &&
                        <div className='row'>
                            <div className='col-12'>
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Komoditas</Form.Label>
                                        <Col sm="4">
                                            <Form.Control type="text" placeholder="Komoditas" className="form-control-sm" value={valueKomoditas} onChange={handleChangeKomoditas} disabled />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    }
                    {
                        jenisIzin === 'CPPIB' &&
                        <div className='row'>
                            <div className='col-12'>
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Peruntukan Produk</Form.Label>
                                        <Col sm="4">
                                            <Form.Control type="text" placeholder="Peruntukan Produk" className="form-control-sm" value={valuePeruntukan} onChange={handleChangePeruntukan} disabled />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    }
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Jenis Sertifikasi</Form.Label>
                                    <Col sm="3">
                                        <AsyncPaginate
                                            loadOptions={loadOptionJenisSert}
                                            value={valueJenisSertOpt}
                                            getOptionValue={(option) => option.jenisSertifikasi}
                                            getOptionLabel={(option) => option.jenisSertifikasi + ' - ' + option.uraianSertifikasi}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangeJenisSert}
                                            isDisabled
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm"><strong>Total Ketidaksesuaian</strong></label>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-1 col-form-label-sm">Sesuai</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="sesuai" value={totalSesuai} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Minor</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="minor" value={totalMinor} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Mayor</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="mayor" value={totalMayor} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Kritis</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="kritis" value={totalKritis} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm"><strong>Hasil / Nilai Kuantitaif</strong></label>
                        <div className="col-sm-3">
                            <input type="text" className="col-sm-12 form-control-sm" name="hasil" value={totalHasil} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Keterangan</label>
                        <div className="col-sm-3">
                            <input type="text" className="col-sm-12 form-control-sm" name="keterangan" value={keterangan} disabled />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Hasil Inspeksi</Form.Label>
                                    <Col sm="8">
                                        <Button size='sm' variant='outline-info' onClick={() => ViewHasilInspeksi()}><FaSearch />{' '}Lihat Hasil Inspeksi</Button>
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            {(dataPrimer.kodeStatus === '027' || dataPrimer.kodeStatus === '029') && (localStorage.getItem("role") === "6" || localStorage.getItem("role") === "7" || localStorage.getItem("role") === "1") && <Button type="button" variant="primary" size="sm" onClick={() => handleClickAddEvaluasi()}><FaPlus /> Tambah Evaluasi Tim Teknis</Button>}
                            <div className="table-responsive border-bottom my-2">
                                {(loading && <Spinner />)}
                                {
                                    listEvaluasi &&
                                    <DataTable
                                        customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                        columns={columnsEvaluasi}
                                        data={listEvaluasi}
                                        highlightOnHover
                                        pagination
                                        persistTableHead={true}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {/* {(dataPrimer.kodeStatus === '027' || dataPrimer.kodeStatus === '029') && listEvaluasi.length === 3 && <Button variant="secondary" size="sm"><FaPaperPlane />Lanjut Rekomendasi Teknis</Button>}{' '} */}
                    {isEdit && (dataPrimer.kodeStatus === '027' || dataPrimer.kodeStatus === '029') && <Button variant="primary" size="sm" onClick={() => handleClickConfimrSimpan()}>Simpan</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            <OffCanvasHasilChecklist showHasilChecklist={showHasilInspeksi} handleCloseHasilChecklist={handleCloseHasilInspeksi} dataDisposisi={dataDisposisi} dataPrimer={dataPrimer} jenisIzin={jenisIzin} />
            <ModalAddEditEvaluasi showEvaluasiTeknis={showEvaluasiTeknis} handleCloseEvaluasiTeknis={handleCloseEvaluasiTeknis} dataEvaluasi={dataEvaluasi} setListEvaluasi={setListEvaluasi} dataPrimer={dataPrimer} jenisIzin={jenisIzin} isEdit={isEditEvaluasi} />
            {
                showConfirmSimpan &&
                <SweetAlert
                    title="Proses?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSimpan ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSimpan}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSimpan}
                    reverseButtons
                >
                    {loadingSimpan && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSimpanSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data  Berhasil"
                    onConfirm={handleCloseSuccess}
                    btnSize="sm"
                />
            }
            {
                showSimpanFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Gagal"
                    onConfirm={handleCloseFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalReviu